import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {BaseModalComponent} from '../base-modal.component';
import {Organization} from '../../_models/organization';
import {PickupLocation} from '../../_models/pickup-location';
import {CustomerArea} from '../../_models/customer-area';
import {CustomerAreaPosition} from '../../_models/customer-area-position';
import {ToastService} from '../../_services/toast.service';
import {CustomerAreaService} from '../../_services/customer-area.service';

@Component({
    selector: 'bb-change-customer-position',
    templateUrl: './change-customer-position.component.html',
    styleUrls: ['./change-customer-position.component.scss'],
})
export class ChangeCustomerPositionComponent extends BaseModalComponent implements OnInit {
    @Input() organization: Organization;
    @Input() pickupLocation: PickupLocation;
    @Input() position: CustomerAreaPosition;
    sanitizedCustomerAreas = [];
    currentArea: CustomerArea;
    currentPosition: CustomerAreaPosition;
    formGroup: FormGroup;

    constructor(
        modalController: ModalController,
        private formBuilder: FormBuilder,
        private toastService: ToastService,
        private customerAreaService: CustomerAreaService
    ) {
        super(modalController);
    }

    ngOnInit() {
        if (!!this.organization && this.organization.customerAreas && !!this.pickupLocation) {
            const customerAreas = this.organization.customerAreas
                .filter(c => !!c.pickupLocations && c.pickupLocations.some(p => p.id === this.pickupLocation.id));

            customerAreas.forEach(c => {
                this.sanitizedCustomerAreas.push(new CustomerArea(c));
            });

            if (!!this.position) {
                this.currentArea = this.sanitizedCustomerAreas.find(c => c.id === this.position.areaId);
                this.currentPosition = this.currentArea.positions.find(c => c.id === this.position.id);
            } else if (this.sanitizedCustomerAreas.length === 1) {
                this.currentArea = this.sanitizedCustomerAreas[0];
            }

            if (!this.currentArea) {
                const area = this.customerAreaService.customerAreaValue;
                this.currentArea = !!area ? this.sanitizedCustomerAreas.find(c => c.id === area.id) : null;
            }

            this.formGroup = this.formBuilder.group({
                area: [this.currentArea, Validators.required],
                position: [this.currentPosition, Validators.required]
            });
        } else {
            this.toastService.error(`No customer areas are defined for ${this.pickupLocation.name}`);
            this.close();
        }
    }

    onSubmit(position) {
        if (!!this.currentArea) {
            this.customerAreaService.setCustomerArea(this.currentArea);
        }
        this.close(!!position ? position : 'NONE');
    }
}
